import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.viewIntegration.integrationParameters.title',
    defaultMessage: 'Integration information',
    description: 'Title of the integration parameters on the integration view',
  },
};

export default defineMessages(translations);
